module.exports = function getResource(label) {
    let resources = {
        removePhoto: 'Remove Photo',
        addPhoto: 'Add Photo'
    };
    return resources[label];
};
